import { create } from "zustand";
import { persist } from "zustand/middleware";
import { postLogout, postNodeLogout } from "../../assets/nodeApi/postApi/postAuthApi";
import { ssoLogoutUrl } from "../constants";

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


const useAuthStore = create()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,

      login: (user, token) => {
        console.log('Logging in user:', user, 'with token:', token);
        set({
          user,
          accessToken: token || "session_active", // Use token as a flag
        });
      },

      logout: async () => {
        try {
          // Wait for logout API to complete
          const result = await postNodeLogout();

          // Check if API was successful (status 200)
          if (result?.status === 200) {
            console.log('Logout API successful');
          } else {
            console.warn('Logout API failed with status:', result?.status);
          }

          // Clear state regardless of API success
          set({ user: null, accessToken: null });
          localStorage.removeItem("auth-storage");

          window.location.href = ssoLogoutUrl;

        } catch (error) {
          console.error('Logout error:', error);
          // set({ user: null, accessToken: null });
          // localStorage.removeItem("auth-storage");
          // await delay(2000);
          // window.location.href = ssoLogoutUrl;
        }
      },

      clearAuth: () => {
        console.log("Clearing auth store and storage...");
        set({ user: null, accessToken: null });
        localStorage.removeItem("auth-storage");


        // If we want a hard reset of the app state to ensure no stale data remains
        // window.location.href = "/SelectLoginPath";
      },

      setUser: (user) => set({ user }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
      }),
    }
  )
);

export default useAuthStore;
